import React from 'react'

function A2() {
    return (
        <div>
            <h1>HELLO3</h1>
        </div>
    )
}

export default A2
